import React from 'react';

import { HelpOutlineOutlined } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import TooltipUnderline from '@wp-react/components/TooltipUnderline';

import TextInput from '../base/TextInput';

type Props = {
  name: string;
};

const exampleVariableTooltip = 'Enter the variable name directly (without double curly braces).';

export default function LoopDefinitionInput({ name }: Props) {
  return (
    <>
      <TextInput
        label="Loop variable reference"
        helperText={
          <>
            Example:{' '}
            <TooltipUnderline title={exampleVariableTooltip}>
              <code>order.lineItems</code>
            </TooltipUnderline>
            .
          </>
        }
        name={`${name}.props.loopTemplate`}
        placeholder="sampleArray"
        InputProps={{
          endAdornment: (
            <Tooltip title="Variable from your data to iterate on. All blocks inside the loop container will be repeated for each item in the array variable. If your variable is blank or can't be loaded, a simple sample array will be used.">
              <span>
                <HelpOutlineOutlined fontSize="small" sx={{ color: 'grey.600' }} />
              </span>
            </Tooltip>
          ),
        }}
      />
      <TextInput
        placeholder="val"
        label="Loop item variable"
        helperText={
          <>
            Example:{' '}
            <TooltipUnderline title={exampleVariableTooltip}>
              <code>lineItem</code>
            </TooltipUnderline>
            .
          </>
        }
        name={`${name}.props.loopArgumentName`}
        InputProps={{
          endAdornment: (
            <Tooltip title="Variable that references the current item in the array.">
              <span>
                <HelpOutlineOutlined fontSize="small" sx={{ color: 'grey.600' }} />
              </span>
            </Tooltip>
          ),
        }}
      />
      <TextInput
        label="Loop index variable"
        placeholder="index"
        name={`${name}.props.loopIndexName`}
        helperText={
          <>
            Example:{' '}
            <TooltipUnderline title={exampleVariableTooltip}>
              <code>index</code>
            </TooltipUnderline>
            .
          </>
        }
        InputProps={{
          endAdornment: (
            <Tooltip title="Variable that references the index of the array.">
              <span>
                <HelpOutlineOutlined fontSize="small" sx={{ color: 'grey.600' }} />
              </span>
            </Tooltip>
          ),
        }}
      />
    </>
  );
}
